import { createContext, useContext, useEffect, useState } from 'react';

const HeaderScrollContext = createContext({
  isHeaderVisible: true,
  isScrolled: false,
});

export function HeaderScrollProvider({ children }) {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY < 10) {
        setIsHeaderVisible(true);
        setIsScrolled(false);
      } else {
        setIsScrolled(true);
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
          setIsHeaderVisible(false);
        } else {
          setIsHeaderVisible(true);
        }
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <HeaderScrollContext.Provider value={{ isHeaderVisible, isScrolled }}>
      {children}
    </HeaderScrollContext.Provider>
  );
}

export function useHeaderScroll() {
  return useContext(HeaderScrollContext);
}
